import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";
import RelatedContent from "@/components/feature/RelatedContent";

const serviceAreas = [
  {
    title: "LAN/WAN Engineering",
    description: "Mitaja has provided multi-resource enterprise network engineering support in federal environments, including LAN/WAN design, implementation, and ongoing operations support.",
    icon: "ri-server-line",
  },
  {
    title: "Server & Collaboration Support",
    description: "Server and collaboration system support for enterprise IT environments, including Windows Server environments and intranet/web platforms.",
    icon: "ri-server-line",
  },
  {
    title: "VMware / vCenter",
    description: "Mitaja has supported VMware vCenter deployment, redundancy configuration, and infrastructure management within enterprise virtualization environments.",
    icon: "ri-server-line",
  },
  {
    title: "Virtualization",
    description: "Virtualization platform support including deployment, migration, and upgrade of enterprise virtual infrastructure.",
    icon: "ri-server-line",
  },
  {
    title: "Infrastructure Modernization",
    description: "Support for infrastructure modernization initiatives, including platform upgrades and technology refresh within enterprise environments.",
    icon: "ri-server-line",
  },
  {
    title: "Platform Deployment & Migration",
    description: "Experience with platform deployment and migration activities in enterprise infrastructure programs.",
    icon: "ri-server-line",
  },
  {
    title: "Enterprise Infrastructure Support",
    description: "Multi-year enterprise infrastructure support providing sustained technical staffing and engineering services for mission-critical IT environments.",
    icon: "ri-server-line",
  },
];

export default function InfrastructureNetworkEngineering() {
  return (
    <Layout>
      <PageHero
        title="Enterprise Infrastructure & Network Engineering"
        subtitle="Proven Core Capability"
        description="LAN/WAN engineering, server and collaboration support, virtualization, and enterprise infrastructure modernization."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2">
              <SectionHeader
                title="Service Areas"
                centered={false}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {serviceAreas.map((area) => (
                  <div key={area.title} className="card-base p-6">
                    <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                      <i className={`${area.icon} text-primary-600`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-900 mb-2">
                      {area.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {area.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/80">
                <h3 className="text-sm font-bold text-primary-800 uppercase tracking-wider mb-3">
                  Technologies
                </h3>
                <div className="flex flex-wrap gap-2">
                  {["LAN/WAN", "VMware", "vCenter", "Windows Server", "Virtualization", "Enterprise Networks"].map((tag) => (
                    <span key={tag} className="text-xs px-2.5 py-1 rounded-full bg-white text-primary-700 font-medium border border-primary-100">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedContent
        subtitle="Related Information"
        title="Infrastructure Experience & Delivery Details"
        description="See the documented federal infrastructure experience behind this capability and how to engage Mitaja."
        links={[
          {
            label: "U.S. Government Infrastructure Experience",
            description: "Documented LAN/WAN, server, virtualization, and database support within federal enterprise IT environments.",
            href: "/experience/usa-government",
            icon: "ri-server-line",
          },
          {
            label: "Capability Statement",
            description: "Review Mitaja's capability statement for procurement, teaming, and qualification review.",
            href: "/resources/capability-statement",
            icon: "ri-file-list-line",
          },
          {
            label: "Contact Mitaja",
            description: "Discuss infrastructure, network engineering, or teaming requirements with our business development team.",
            href: "/contact",
            icon: "ri-mail-line",
          },
        ]}
      />

      <CTAPanel
        title="Need Infrastructure Expertise?"
        description="Mitaja provides qualified network engineers, infrastructure specialists, and technical SMEs for enterprise and government programs."
        secondaryAction={{ label: "View Past Performance", href: "/experience" }}
        variant="dark"
      />
    </Layout>
  );
}